<template>
    <div>
        <div :class="{'hide': !showMenu}">
            <el-menu
                    :default-active="selected"
                    @select="selectItem" unique-opened>
                <template v-for="item in menu.menus">
                    <el-menu-item :index="item.id" v-if="item.leafNode === 1">
                        <template slot="title">
                            <span slot="title" ><i class="iconfont" :class="[item.icon]"></i>{{item.label}}</span>
                        </template>
                    </el-menu-item>
                    <el-submenu :index="item.id" v-if="item.leafNode === 0">
                        <template slot="title">
                            <span slot="title"><i class="iconfont" :class="[item.icon]"></i>{{item.label}}</span>
                        </template>
                        <el-menu-item :index="child.id" v-for="child in item.childs" :key="child.pk" style="padding-left: 85px">{{child.label}}</el-menu-item>
                    </el-submenu>
                </template>
            </el-menu>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapState} from 'vuex';

    export default {
        name: 'sideMenu',
        data() {
            return {
                showMenu: true
            };
        },
        computed: {
            ...mapState('sideMenu', ['menu', 'selected']),
            ...mapGetters('sideMenu', ['getMenuItem'])
        },
        methods: {
            selectTitle() {
                this.$emit('index', '', '', '');
            },
            selectItem(index, path) {
                let menuItem = this.getMenuItem(path);
                this.$emit('select', menuItem, index, path);
                this.$store.commit('sideMenu/SET_SELECTED', {index, path});
            }
        },
        created() {
            this.$store.dispatch('sideMenu/loadMenu');
        }
    };
</script>
<style scoped>
    .el-menu {
        border-right: none;
    }
    .el-menu li {
        width: 100%;
        color: #D8F1FB;
        background-color: #2563AA;
    }
    .el-menu li .iconfont {
        font-size: 24px;
        margin-right: 10px;
    }
    .el-submenu li {
        width: 100%;
        color: #D8F1FB;
        background-color: #2563AA;
    }
    .el-menu-item span, .el-submenu span {
        font-size: 16px;
    }
    .el-submenu__title span{
        color: #D8F1FB;
    }
    .el-menu-item.is-active, .el-menu-item.is-active:hover {
        background-color: #1E4F88;
        color: #5ED1FD;
    }
</style>
